import ScrollMagic from 'scrollmagic';

export default function anchors() {

    let $root = $('html, body');

    $('._anchor-link[href^="#"]').click(function () {
        $root.animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top
        }, 500);

        return false;
    });
}